export default "__VITE_ASSET__DlemICMx__"